import React, {Component} from 'react';


import Modal from "react-bootstrap/Modal";
import {connect} from "react-redux";
import Swal from 'sweetalert2';

import AgentAvatar from "../agents/AgentAvatar";
import { toast } from 'react-toastify';
import {removeAgents, sendTransfer} from "../../actions/actions"
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class UserBan extends Component {

    constructor(props) {

        super(props);
        this.state={
            selectedAgent:0
        }
        this.selectedAgent=this.selectedAgent.bind(this);
        this.sendTransfer=this.sendTransfer.bind(this);
    }
    selectedAgent(e,id){
        this.setState({
           selectedAgent:id
        });
    }
    sendTransfer(e,id){

        if(this.state.selectedAgent==0){
            toast.error("please choose agent");
            return false;
        }
        Swal.fire({
            title: 'Are you sure you want to transfer the chat to another agent ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(sendTransfer({
                    chat_id:id,
                    agent_id:this.state.selectedAgent
                }));
            }
        });

        e.preventDefault();
    }


    render() {
        const {t} = this.props


        return (

            <>

                <Modal.Header closeButton>
                    <Modal.Title>User Ban</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <ul className="agent-transfer transfer">
                        {this.props.chatprop.allAgents.filter(agent => agent.id != this.props.chatprop.operator.id && agent.status==1).map(filteredAgent => (
                              <li
                                  onClick={e=>this.selectedAgent(e, filteredAgent.id)}
                                  className={""+this.state.selectedAgent==filteredAgent.id ? "active" : ""}
                              >
                                    <div>
                                        <AgentAvatar user={filteredAgent}/>
                                    </div>
                                    <div className="agent-body">
                                    <div>
                                    <h5>{filteredAgent.username}</h5>
                                    <p className="active-chat-total">
                                        {filteredAgent.active_chat > 0 &&
                                            <span>{filteredAgent.active_chat} active chat</span>
                                        }
                                        {filteredAgent.active_chat <1 &&
                                        <span>no active chats</span>
                                        }

                                    </p>
                                    </div>

                                    </div>
                                    </li>
                            ))}


                    </ul>

                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="chat-button chat-button-success ml-1 "
                            onClick={e=>this.sendTransfer(e,this.props.chatprop.modal.data.id)}
                    >
                        <span>Transfer</span>
                    </button>
                </Modal.Footer>
            </>

        );
    }
}

export default UserBan;
